export default __webpack_public_path__ + "5d5f8a4774d6f06d9976d06e5079baa4.png";